import BottomTabsMenu from './BottomTabsMenu';

export default BottomTabsMenu;
